import {
  Box,
  Button,
  gridClasses,
  Switch,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import { useOrganization } from "../utils/OrganizationContext";

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const MUTED = "#66748A";
const LINE = "#E4E9EF";
const PRIMARY = "#0B5C8A";
const smallBtn = {
  height: 30,
  minWidth: 0,
  px: 1.5,
  borderRadius: "8px",
  border: "1px solid #D5DEE7",
  background: "#FFFFFF",
  color: INK,
  fontFamily: FONT,
  fontSize: 12.5,
  fontWeight: 600,
  textTransform: "none",
  "&:hover": { background: "#EAF2FB", borderColor: "#C9DEF3", color: "#1B4F82" },
};
const switchSx = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: "#FFFFFF" },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { background: PRIMARY, opacity: 1 },
  "& .MuiSwitch-track": { background: "#C3CDD9", opacity: 1 },
};

const Partners = () => {
  const [partners, setPartners] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  // const [role, setRole] = useState();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 750px)");
  const orgId = JSON.parse(localStorage.getItem("org"));
  const { role } = useOrganization();

  useEffect(() => {
    // const decoded = jwtDecode(storedUser.accessToken);
    // setRole(decoded.userRole[0]);

    const getPartners = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/partner/all?orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setPartners(res.data);
      } catch (error) {
        console.log(error.response.data.Exception || "Access denied");
      }
    };
    getPartners();
  }, [orgId]);

  const columns = [
    {
      field: "partnerId",
      headerName: "Partner ID",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontFamily: MONO, fontSize: 12.5, color: "#3D4C60" }}>{params.value}</span>
      ),
    },
    {
      field: "companyName",
      headerName: "Company Name",
      flex: 1,
    },
    {
      field: "partnerName",
      headerName: "Partner Name",
      flex: 1,
      renderCell: (params) => <span style={{ fontWeight: 700 }}>{params.value}</span>,
    },
    {
      field: "mobile",
      headerName: "Mobile No.",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontFamily: MONO, fontSize: 12.5 }}>
          {params.value
            ? params.row.countryCode != null
              ? `${params.row.countryCode}${params.value}`
              : `+${params.value}`
            : "-"}
        </span>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    (role === "ADMIN" || role === "PROJECT_HEAD") && {
      field: "action",
      headerName: "Access Enable/Disable",
      width: 200,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Switch
            defaultChecked={params.row.isAllowed}
            onClick={() => handleEnableDisable(params.row.partnerId)}
            size="small"
            sx={switchSx}
          />
          <Button
            onClick={() => navigate(`/dashboard/partner/${params.row.partnerId}`)}
            sx={smallBtn}
          >
            Edit
          </Button>
        </Box>
      ),
    },
  ];

  const rows = partners ? partners : "";

  const handleEnableDisable = async (partnerId) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/partner/access?partnerId=${partnerId}&orgId=${orgId}`,
        {},
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div style={{ fontFamily: FONT, color: INK, textAlign: "left" }}>
      <Box
        sx={{
          display: { xs: "block", sm: "flex" },
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          variant="h4"
          my={1}
          sx={{ fontFamily: FONT, fontSize: 27, fontWeight: 800, letterSpacing: "-0.028em", color: INK }}
        >
          List of Partners
        </Typography>
        <Link to={`/dashboard/add-partner`} style={{ textDecoration: "none" }}>
          <Button
            className="btn-contained"
            sx={{
              width: { xs: "100%", sm: "auto" },
              height: 40,
              px: 2,
              margin: "0 !important",
              gap: 1,
              borderRadius: "10px !important",
              background: `${PRIMARY} !important`,
              color: "#FFFFFF !important",
              border: "0 !important",
              fontFamily: FONT,
              fontSize: 13.5,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { background: "#084767 !important" },
            }}
          >
            <PersonAddAltRoundedIcon sx={{ fontSize: 18 }} /> Add Partner
          </Button>
        </Link>
      </Box>
      <div>
        {isMobile ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
            {partners?.map((p) => (
              <div
                key={p.partnerId}
                className="card"
                style={{ margin: 0, padding: "14px 16px", background: "#FFFFFF", border: `1px solid ${LINE}`, borderRadius: 14, boxShadow: "none" }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}
                >
                  <div style={{ minWidth: 0 }}>
                    <Typography
                      fontSize={"17px"}
                      color={INK}
                      fontWeight={"800"}
                      sx={{ fontFamily: FONT, letterSpacing: "-0.02em" }}
                    >
                      {p.partnerName}
                    </Typography>
                    <Typography
                      fontSize={"12px"}
                      color={MUTED}
                      fontWeight={"500"}
                      sx={{ fontFamily: MONO }}
                    >
                      ID: {p.partnerId}
                    </Typography>
                  </div>
                  <div>
                    <Switch
                      defaultChecked={p.isAllowed}
                      onClick={() => handleEnableDisable(p.partnerId)}
                      sx={switchSx}
                    />
                  </div>
                </div>
                <Typography
                  color={MUTED}
                  fontSize={"13.5px"}
                  fontWeight={500}
                  mt={1.25}
                  sx={{ display: "flex", alignItems: "center", gap: 1.25, fontFamily: FONT }}
                >
                  <CallIcon sx={{ fontSize: 16, color: "#8A97A8" }} />{" "}
                  <span style={{ fontFamily: MONO, fontSize: 13, color: INK }}>
                    {p.mobile ? `+${p.mobile}` : "-"}{" "}
                  </span>
                </Typography>
                <Typography
                  color={MUTED}
                  fontSize={"13.5px"}
                  fontWeight={500}
                  mt={0.75}
                  mb={1.25}
                  sx={{ display: "flex", alignItems: "center", gap: 1.25, fontFamily: FONT, wordBreak: "break-all" }}
                >
                  <EmailIcon sx={{ fontSize: 16, color: "#8A97A8" }} /> {p.email}
                </Typography>
                <hr style={{ border: 0, borderTop: "1px solid #EDF1F5", margin: "0 0 10px" }} />
                <div
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}
                >
                  <Typography
                    color={MUTED}
                    fontSize={"13px"}
                    fontWeight={600}
                    sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}
                  >
                    <MeetingRoomOutlinedIcon sx={{ fontSize: 16, color: "#8A97A8" }} />{" "}
                    <span style={{ color: INK, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.companyName}</span>
                  </Typography>
                  <Button
                    onClick={() => navigate(`/dashboard/partner/${p.partnerId}`)}
                    sx={{ ...smallBtn, height: 40, px: 2.5, flex: "0 0 auto" }}
                  >
                    Edit
                  </Button>
                </div>
              </div>
            ))}
          </Box>
        ) : (
          <Box sx={{ background: "#fff", border: `1px solid ${LINE}`, borderRadius: "14px", overflow: "hidden" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 20,
                  },
                },
              }}
              pageSizeOptions={[20]}
              disableRowSelectionOnClick
              disableColumnSelector
              disableDensitySelector
              slots={{ toolbar: CustomToolbar }}
              getRowId={(row) => row.partnerId}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
              }
              rowHeight={50}
              sx={{
                position: "relative",
                border: "none",
                fontFamily: `${FONT} !important`,
                color: INK,

                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "700 !important",
                  fontSize: 10.5,
                  letterSpacing: "0.09em",
                  textTransform: "uppercase",
                  color: MUTED,
                },
                "& .MuiDataGrid-columnHeaders": {
                  background: "#F7F9FC !important",
                  color: MUTED,
                  fontSize: "14px",
                  borderRadius: 0,
                },
                "& .MuiDataGrid-columnHeader": { background: "#F7F9FC" },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#F7F9FC",
                },
                "& .MuiDataGrid-cell": {
                  fontSize: "13.5px",
                  border: "none",
                  borderBottom: "1px solid #F1F4F8",
                  display: "flex",
                  alignItems: "center",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                "& .MuiInputBase-root-MuiInput-root::after": {
                  borderBottom: "none !important",
                },
                "& .MuiInputBase-root-MuiInput-root": {
                  borderBottom: "none !important",
                },
                [`& .${gridClasses.row}.even`]: {
                  backgroundColor: "#FFFFFF",
                  // '&:hover': {
                  //   backgroundColor: "#f6f6f6",
                  // },
                },
                "& .MuiInput-underline:before": {
                  borderBottom: "none !important",
                },
                "& .MuiDataGrid-footerContainer": { borderTop: `1px solid ${LINE}` },
                "& .MuiTablePagination-displayedRows": { fontFamily: MONO, fontSize: 12, color: MUTED },
              }}
            />
          </Box>
        )}
      </div>
    </div>
  );
};

export default Partners;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end", p: "10px 12px", borderBottom: "1px solid #EDF1F5" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #D5DEE7",
          borderRadius: "10px",
          padding: "2px 10px",
          background: "#FFFFFF",
          "&:hover": {
            borderColor: "#B4C6DA",
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
            fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
            fontSize: 13.5,
          },
          "& .MuiSvgIcon-root": { color: "#8A97A8", fontSize: 18 },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
